var map = {
	"./hartvannederland.yml": 2960,
	"./radio10.yml": 6100,
	"./radio538.yml": 9252,
	"./shownieuws.yml": 9498,
	"./skyradio.yml": 7261,
	"./vandaaginside.yml": 3259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1529;